module.exports = __webpack_public_path__ + "static/img/baozhuang.20c8e8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AboutUS/honors/baozhuang.png
// module id = PUZ3
// module chunks = 7